import React, { useEffect } from 'react'
import i18next from 'i18next'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import ChangePassword from '../password/ChangePassword'
import SavePIN from '../security/SavePIN'
import NotificationSettings from '../pushNotification/NotificationSettings'
import { withNamespaces } from 'react-i18next';
import * as storage from '../../utils/storage';

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

function TabSettings(props) {
    const [value, setValue] = React.useState(0);
    const [index, setIndex] = React.useState(0);
    const [isNotificationActivate, setIsNotificationActivate] = React.useState(storage.getIsNotificationActivate());

    useEffect(() => {
    });

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handlePanelPasswordClick = () => {
        setIndex(0);
    }

    const handlePanelPINClick = () => {
        setIndex(1);
    }

    const handlePanelNotificationClick = () => {
        setIndex(2);
    }

    const handleClose = () => {
        setTimeout(() => {
            // setTimeout to show the success message and then return to the menu
            props.onShowAllMenu();
        }, 2000);
    }

    return (
        <React.Fragment>
            <div className={"rootMyFile"}>
                <AppBar position="static" color="default">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        variant="scrollable"
                        indicatorColor="primary"
                        scrollButtons="on"
                        textColor="primary"
                        className={"TabPage"}
                    >
                        <Tab className={"TabPageButton"} label={i18next.t("settings:tabPanel.password")} {...a11yProps(0)} onClick={handlePanelPasswordClick} />
                        <Tab className={"TabPageButton"} label={i18next.t("settings:tabPanel.pin")} {...a11yProps(1)} onClick={handlePanelPINClick} />
                        {isNotificationActivate === true && <Tab className={"TabPageButton"} label={i18next.t("settings:tabPanel.notification")} {...a11yProps(2)} onClick={handlePanelNotificationClick} />}
                    </Tabs>
                </AppBar>

                {index == 0 && <ChangePassword handleClose={handleClose} />}
                {index == 1 && <SavePIN handleClose={handleClose} />}
                {isNotificationActivate === true && index == 2 && <NotificationSettings />}
            </div>
        </React.Fragment>
    );
}

export default withNamespaces(['settings'], { wait: true })(TabSettings);